let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("712kb")).then(() => parcelRequire('bsSEQ'));